import styled from 'styled-components';
import { colorGrey200, colorGreen400, fontFamilyRoboto, colorBlack900 } from 'styleUtils';
export var CheckboxWrapper = /*#__PURE__*/styled.label.withConfig({
  componentId: "sc-13rlav-0"
})(["display:flex;align-items:center;&:not(:last-child){margin-bottom:16px;}"]);
export var CheckboxContainer = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-13rlav-1"
})(["display:inline-block;vertical-align:middle;"]);
export var HiddenCheckbox = /*#__PURE__*/styled.input.attrs({
  type: 'checkbox'
}).withConfig({
  componentId: "sc-13rlav-2"
})(["border:0;clip:rect(0 0 0 0);clip-path:inset(50%);height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;white-space:nowrap;width:1px;"]);
export var StyledCheckbox = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-13rlav-3"
})(["display:inline-block;margin-right:16px;width:24px;height:24px;background:", ";border:", ";border-radius:2px;cursor:pointer;transition:all 150ms;position:relative;left:0px;top:2px;& svg{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);width:14px;height:11px;}& *{visibility:", ";}"], function (_ref) {
  var checked = _ref.checked;
  return checked && colorGreen400;
}, function (_ref2) {
  var checked = _ref2.checked;
  return checked ? "none" : "2px solid ".concat(colorGrey200);
}, function (_ref3) {
  var checked = _ref3.checked;
  return checked ? 'visible' : 'hidden';
});
export var CheckboxText = /*#__PURE__*/styled.span.withConfig({
  componentId: "sc-13rlav-4"
})(["", ":none;", ":none;", ":none;", ":none;", ":none;user-select:none;font-family:", ";font-size:14px;line-height:24px;color:", ";"], '-webkit-touch-callout', '-webkit-user-select', '-khtml-user-select', '-moz-user-select', '-ms-user-select', fontFamilyRoboto, colorBlack900);